module.exports = __webpack_public_path__ + "static/media/gcp-card-icon.c4363e66.png";